module.exports = __webpack_public_path__ + "media/images/front/pc/routable/img02-f27452700747ea3e001d7b25ed003c07.png";